import { gql } from '@apollo/client';

// Optional preview-only operation, intentionally separate from GET_FILLER_VIDEOS
// so older backends don't break the catalog query during a rolling deployment.
export const GET_FILLER_VIDEO_PREVIEWS = gql`
  query fillerVideoPreviews {
    fillerVideos {
      id
      file_url
      file_en_url
      preview_url
      preview_en_url
      preview_duration_seconds
      preview_en_duration_seconds
    }
  }
`;
